<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource && localesLoaded">

                    <header>
                        <figure>
                            <i v-if="!resource.picture" class="icon icon-icon_calendar"></i>
                            <img v-if="resource.picture" :src="resource.picture.url+'/fit/100x100'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Reservation <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1><schedule :start-at="resource.start_at" :end-at="resource.end_at"></schedule></h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="remove()" class="bt-primary bt-delete" v-if="resource.id"><span><icon name="trash-01"/></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                        <div class="notice-invoice" v-if="resource.order && resource.order.invoice" v-bind:class="{'completed':resource.order.invoice.is_transaction_completed, 'pending':!resource.order.invoice.is_transaction_completed}">
                            <div v-if="resource.order.invoice.is_transaction_completed">
                                <i class="icon icon-order-success status-completed"></i>
                                La facture est payée
                            </div>
                            <div v-if="!resource.order.invoice.is_transaction_completed">
                                <i class="icon icon-order-pending status-pending"></i>
                                La facture n'est pas encore payée
                            </div>
                            <!--<div><button @click="editInvoice" v-if="!resource.order.invoice.is_transaction_completed"><span>Modifier</span></button></div>-->
                            <div><button @click="print"><span>Imprimer la facture</span></button></div>
                        </div>
                        <div class="notice-invoice pending" v-if="resource.id && !resource.order">
                            <div>
                                <i class="icon icon-icon_chat-circle"></i>
                                A facturer au client !
                            </div>
                            <!--<div><button @click="linkOrder"><span>Associer</span></button></div>-->
                            <div><button @click="generateOrder"><span><i class="icon icon-icon_money"></i> Encaisser</span></button></div>
                        </div>
                    </header>

                    <main>

                        <modal
                                v-model="order"
                                v-if="isModalOrderVisible"
                                :is-modal="true"
                                @close="closeModal"
                                @validate="validateModal"/>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Detail">

                                <fieldset>
                                    <h3>Information</h3>
                                    <p class="headline"></p>

                                  <div style="margin-bottom: 1em;">
                                    <div v-for="item in selectedSlots" v-bind:style="{background:item.color}" style="font-size:13px;padding:5px 10px;display:inline-block;margin:4px;border-radius:3px;color:#fff;">
                                      <label style="font-weight: bold;">{{ item.name }}</label> | <span style="font-size: 0.9em;">{{ item.description }}</span>
                                    </div>
                                  </div>

                                  <form-checklist label="Type" v-model="resource.type" :options="types" :multiple="false" v-show="resource.order == null"></form-checklist>

                                  <div v-if="resource.type == 'reservation'">

                                    <entity label="Client" v-model="entity" :default="resource.client_id" :callback="updateEntity" :show-company="false" :show-create="true" :show-detail="true"></entity>

                                    <div v-if="resource.order_products && resource.order_products.length <= 0 && !resource.product">
                                      <!--<div v-if="products_credit">{{ products_credit.length + ' avoir(s) disponible(s)' }}</div>-->
                                      <form-checklist label="Type de prestations" v-if="product_type_active" v-model="product_type" :options="product_types" :multiple="false"></form-checklist>
                                      <form-select label="Avoir" v-if="product_type == 'credit'" v-model="resource.credit" :options="products_credit" :callback="updateOrderProduct" multiple="false"></form-select>
                                      <form-autocomplete v-if="product_type == 'product'" label="Prestation" v-model="resource.product" :default="resource.product_id" :service="productService" :callback="updateProduct"></form-autocomplete>
                                    </div>

                                    <div class="form-field form-products" v-if="resource.product">
                                      <div class="form-label"></div>
                                      <div class="form-input">
                                        <div class="product-listing">
                                          <div v-if="resource.product.picture" style="background: #eee;aspect-ratio: 1/1;"><img :src="resource.product.picture + '/fit/100xauto'"/></div>
                                          <div v-else style="background: #eee;aspect-ratio: 1/1;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="/></div>
                                          <div>
                                            <span class="name">{{ resource.product.name }}</span>
                                            <span class="sku">{{ resource.product.sku }}</span>
                                          </div>
                                          <div><button @click="removeProduct()" class="bt bt-primary"><span>Supprimer</span></button></div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="form-field form-products" v-if="resource.order_products && resource.order_products.length > 0">
                                      <div class="form-label"></div>
                                      <div class="form-input">
                                        <div v-for="(product, index) in resource.order_products" class="product-listing">
                                          <div v-if="product.original_product.picture" style="background: #eee;aspect-ratio: 1/1;"><img :src="product.original_product.picture + '/fit/100xauto'"/></div>
                                          <div v-else style="background: #eee;aspect-ratio: 1/1;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="/></div>
                                          <div>
                                            <span class="label">Avoir</span>
                                            <span class="name">{{ product.name }}</span>
                                            <span class="sku">{{ product.original_product.sku }}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>

                                    <form-textarea label="Commentaire" v-model="resource.comment"></form-textarea>

                                </fieldset>

                                <fieldset>
                                  <h3>Informations complémentaires</h3>
                                  <p class="headline"></p>

                                  <form-toggle label="Responsable" v-model="resource.auto_assign_user" label-true="auto" label-false="manuel"></form-toggle>
                                  <form-autocomplete v-show="!resource.auto_assign_user" label="Responsable" multiple="false" v-model="resource.user" :default="resource.user_id" :service="userService"></form-autocomplete>
                                  <form-text label="Titre" v-model="resource.name"></form-text>

                                </fieldset>

                            </tab>
                            <tab name="Avancé">

                                <fieldset>
                                    <h3>Planning</h3>
                                    <p class="headline"></p>

                                    <div v-for="branch in branches">
                                        <form-checklist :label="branch.name"
                                                        v-model="branch.slots"
                                                        :options="branch.slotables"
                                                        :default="slot_ids"
                                                        :multiple="true"
                                                        color="color"
                                                        :callback="updateSlots">
                                        </form-checklist>
                                    </div>

                                  <form-datetime label="Début" v-model="resource.start_at" @update="refresh"></form-datetime>

                                  <form-datetime label="Fin" v-model="resource.end_at" @update="refresh"></form-datetime>

                                </fieldset>

                            </tab>
                            <tab name="Facture" v-if="resource.invoice_details">

                              <fieldset>
                                <h3>Facture</h3>
                                <p class="headline"></p>

                                <invoice v-model="resource.invoice_details"></invoice>

                              </fieldset>

                            </tab>
                        </tabs>

                        <span v-html="cssComputed"></span>

                    </main>
                    <footer>
                    </footer>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import ScheduleService from './ScheduleService.js';
    import UserService from '../scope/UserService.js';
    import ScopeService from '../scope/ScopeService.js';
    import BranchService from '../config/branch/BranchService.js';
    import ProductService from './../shop/product/ProductService.js';
    import OrderService from './../shop/order/OrderService.js';

    import Edit from '../../layouts/Edit.vue';
    import Modal from '../shop/order/Edit.vue'

    export default {
        extends: Edit,
        props: ['event','branchFilter','personFilter'],
        components:{
            Modal,
        },
        data () {
            return {
                currency: null,
                price: null,
                attributes: [],
                resource: {},
                config: null,
                entity: null,
                test: ['block'],
                types: [
                    {id:'reservation', name:'Réservation'},
                    {id:'block', name:'Bloquage'}
                ],
                user_id: null,
                userService: null,
                productService: null,
                isLoading: false,
                slots: [],
                branches: null,
                cssComputed: null,
                client_firstname: null,
                client_lastname: null,
                client_email: null,
                client_mobile: null,
                resourceslots: null,
                isModalOrderVisible: false,
                order: null,
                slot: null,
                slot_ids: [],
                selectedSlots: [],
                product_type_active: false,
                products_credit: null,
                product_types: [ { id:'product', name:'Prestation' }, { id:'credit', name:'Avoir' } ],
                product_type: 'product',
                productsCredit: null
            }
        },
        mounted: function(){

            this.userService = UserService;
            this.productService = ProductService;

            this.currency = this.$store.state.scope.currency_id
            this.price = 'HT'

            /*
            ScopeService.get(this.$store.state.scope.id).then((response) => {
                this.cssComputed = '<style>.content-body{padding:0px;}';
            });
            */

          console.log("edit window", this.event)

            this.cssComputed = '<style>.content-body{padding:0px;}';

            if(this.event)
            {
                this.slot = this.event.slots[0];
            }else{
                this.slot = null;
            }

        },
        methods:{
            refresh: function(){
              this.$forceUpdate();
            },
            print: function()
            {
                if( this.resource.order && this.resource.order.invoice )
                {
                    window.open(this.resource.order.invoice.download_link, 'Download Invoice');
                }
            },
          removeProduct: function(){
            if( this.resource.order_id || this.resource.order ){
              alert("Impossible de modifier le produit, car il est associé à une commande")
              return false;
            }
            this.resource.product = null;
            this.resource.product_id = null;
            this.$forceUpdate();
          },
            removeOrderProduct: function(index)
            {
              alert(index);
              this.resource.order_products.splice(index, 1);
            },
            linkOrder: function()
            {

            },
            editInvoice: function()
            {
              let branch_id = this.selectedSlots.length ? this.selectedSlots[0].branch_id : null;

              if( this.entity && this.entity.entity.id )
              {

                this.order = this.resource.order;
                this.isModalOrderVisible = true;

              }else{

                alert("Veuillez sélectionner un client")

              }
            },
            generateOrder: function()
            {

                let branch_id = this.selectedSlots.length ? this.selectedSlots[0].branch_id : null;

                if( this.entity && this.entity.entity.id )
                {

                  this.order = {
                    id: null,
                    user: null,
                    user_id: this.resource.user.id,
                    client: null,
                    clientable_id: this.entity.entity.id,
                    product: this.resource.product,
                    branch_id: branch_id,
                    order_status: "terminated",
                    payment_status: "completed",
                    schedule: this.resource || null,
                    language: 'fr',
                  };
                  this.isModalOrderVisible = true;

                }else{

                  alert("Veuillez sélectionner un client")

                }

            },
            resourceLoaded: function(){

                let defaultUserId = this.slot && this.slot.user_id ? this.slot.user_id : this.$store.state.user.id

                this.localesLoaded = true;
                this.resource.slots = this.resource.slots || [];
                this.resource.order_products =  this.resource.order_products || [];
                this.resource.user_id = this.resource.user_id || defaultUserId;

                if( this.resource.id == null )
                {
                    this.resource.auto_assign_user = true
                }

                if( this.$route.meta.action == "new" )
                {
                    let slots = [];
                    this.resource.start_at = this.$route.params.event ? this.$route.params.event.start : null
                    this.resource.end_at = this.$route.params.event ? this.$route.params.event.end : null
                    this.resource.type = this.$route.params.event ? this.$route.params.event.type : null
                }

                BranchService.query().then(response => {
                    this.branches = response.data.data
                    this.isLoading = false;

                    for (let branch of this.branches) {
                        branch.slots = []
                        for (let slot of branch.slotables) {
                            slot.description = slot.is_public ? "Public" : "Privé"
                            if( this.resource.slots.indexOf(slot.id) >= 0 || (this.slot && this.slot.id == slot.id) )
                            {
                                branch.slots.push( slot.id );
                            }
                        }
                    }

                  this.updateSlots();

                });

                if(this.personFilter) {
                    this.resource.user_id = this.personFilter.id
                }

                /* CONVERT DATES TO LOCAL TIMZONE */
                this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null;
                this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null;
                /*****/


                this.initialize();
                this.$forceUpdate();

            },
            beforeUpdate: function(Resource){
                //Resource.user = this.resource.user && this.resource.user.email ? this.resource.user : null
                Resource.slots = [];

                if( this.product_type == "credit")
                {
                    Resource.product = null;
                }

                for (let branch of this.branches) {
                    for (let slot of branch.slots) {
                        Resource.slots.push(slot);
                    }
                }

                return true
            },
            updateSlots: function()
            {
                this.selectedSlots = [];
                if( this.branches )
                {
                    for (let branch of this.branches) {
                        for (let slot of branch.slotables) {

                            if( branch.slots.indexOf(slot.id) >= 0 )
                            {
                                this.selectedSlots.push({
                                    id: slot.id,
                                    branch_id: branch.id,
                                    name: slot.name,
                                    description: branch.name,
                                    color: slot.color
                                });
                            }
                        }
                    }
                }
            },
            getResource: function(){
                return ScheduleService
            },
            updateProduct: function(item){

              //console.log("updateProduct", item.id, this.resource.product.id, this.defaultProductSelected)

                if( item && item.id && this.resource ){

                    if( item.type_of != 'service' ){
                        alert("Veuillez sélectionner une prestation de service et non un produit.");
                        this.resource.name = ''
                        this.resource.product = null
                        return false;
                    }

                    if( item && item.has_bundles > 0 )
                    {

                        alert("Un forfait ne peut pas être attribué à un rendez-vous, veuillez sélectionner un soin ou une séance.");
                        this.resource.name = ''
                        this.resource.product = null
                        return false;

                    }else if( item && item.duration && item.duration > 0 )
                    {

                        this.resource.name = item.shortname ? item.shortname : item.name

                        if( this.resource.start_at )
                        {

                            if( this.resource.product_id != item.id ){
                                let confirm = window.confirm("Souhaitez-vous mettre à jour la durée du rendez-vous ?");
                                if( confirm )
                                {

                                    // Change duration automatically
                                    let duration = item.duration + (item.preparation_time ? item.preparation_time : 0)
                                    let end_at = moment(this.resource.start_at).add(duration, 'm').toISOString();
                                    if( end_at )
                                    {
                                        this.resource.end_at = end_at
                                        this.$forceUpdate();
                                    }
                                }
                            }
                        }

                    }else{

                        alert("La durée du produit n'est pas définie. Veuillez changer l'heure de fin manuellement.")

                    }

                    this.$forceUpdate();
                }else{

                    this.resource.name = ''
                    this.resource.product = null

                }

            },
            updateOrderProduct: function(value){

                this.resource.order_id = value.order_id ? value.order_id : null;
                this.resource.order_product_id = value.order_product_id ? value.order_product_id : null;
                this.resource.product = null;

                if( value.id )
                {
                    ProductService.get(value.id).then(response => {
                        this.resource.product = response.data;
                        this.updateProduct(response.data);
                    });
                }

            },
            updateEntity: function(value){

                if( value && value.entity )
                {
                    this.type = value.type

                    this.resource.client = value.entity
                    this.client_firstname = value.entity.firstname
                    this.client_lastname = value.entity.lastname
                    this.client_email = value.entity.email
                    this.client_mobile = value.entity.phone_mobile

                    if(value.entity.id) {

                        OrderService.getOrderCredit(value.entity.id).then(response => {
                            if(response.data.length > 0) {
                                this.products_credit = [];
                                for (let orderItem of response.data) {
                                    this.products_credit.push({
                                        'id': orderItem.original_product_id,
                                        'order_product_id': orderItem.id,
                                        'order_id': orderItem.order_id,
                                        'name': orderItem.name,
                                        'description': this.$store.state.scope.currency_id + " " +orderItem.original_product.price.ttc.toFixed(2) + (orderItem.original_product.duration ? " - " + orderItem.original_product.duration + " minutes" : ""),
                                    });
                                }
                                this.product_type_active = true;
                            }else{
                                this.products_credit = null;
                                this.product_type_active = false;
                                this.resource.order_id = null;
                                this.resource.order_product_id = null;
                                //this.resource.product = null;
                            }
                        });

                    }else{
                        this.products_credit = null;
                        this.product_type_active = false;
                        this.resource.order_id = null;
                        this.resource.order_product_id = null;
                        //this.resource.product = null;
                    }

                }else{
                    this.products_credit = null;
                    this.product_type_active = false;
                    this.resource.order_id = null;
                    this.resource.order_product_id = null;
                    //this.resource.product = null;
                }

            },
            closeModal() {
                this.order = null
                this.isModalOrderVisible = false;
            },
            validateModal(order) {

                let self = this;

                let params = {
                  start_at: this.resource.start_at,
                  end_at: this.resource.end_at
                };

                if( order.id )
                {
                    ScheduleService.setOrderId(this.resource.id, order.id, params).then((response) => {
                        self.resource.order = response.data.order;
                        self.$forceUpdate();
                    });
                }

                this.closeModal()
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/reservation/Edit.vue